module.exports = __webpack_public_path__ + "assets/d7e4b9226f921111be6c593d709083c1.svg";